export enum ViewSectionType {
    Left = 1,
    Right = 2
}